import { PreliminaryData } from "models/ResultPacket/ResultPacket";
import React from "react";
import l10n from "localization/LocalizationData";
import { GenderKeys } from "models/ResultPacket/Gender";
import { ActivityKeys } from "models/ResultPacket/Activity";
import { EducationKeys } from "models/ResultPacket/Education";
import { FirstLanguageKeys } from "models/ResultPacket/FirstLanguage";
import { FillReasonKeys } from "models/ResultPacket/FillReason";
import { NoAnswer } from "models/ResultPacket/Preliminary";


interface PreliminaryFieldProps {
	preliminaries: PreliminaryData;
}

const PreliminaryFieldEntry = (props: { title: string, value?: string }) => {
	return (
		<div className='prelim-row'>
			<p className='prelim-left'>{props.title} </p>
			<p className='prelim-right'>{props.value}</p>
		</div>
	)
}

export const PreliminaryField = (props: PreliminaryFieldProps) => {
	return (
		<div className='preliminary-field-container'>
			<h2>{l10n.preliminary_title}</h2>

			<ul className='preliminary-field-list'>

				{
					props.preliminaries.age &&
					<PreliminaryFieldEntry title={l10n.preliminary_answer_age_title}
						value={props.preliminaries.age} />
				}
				{
					props.preliminaries.gender &&
					<PreliminaryFieldEntry title={l10n.preliminary_answer_gender_title} value={props.preliminaries.gender.value === NoAnswer
						? l10n.finish_noAnswer
						: l10n.preliminary_gender_choices[props.preliminaries.gender.value as GenderKeys]} />
				}
				{

					props.preliminaries.firstlanguage &&
					<PreliminaryFieldEntry title={l10n.preliminary_answer_firstLanguage_title} value={props.preliminaries.firstlanguage.value === NoAnswer
						? l10n.finish_noAnswer
						: props.preliminaries.firstlanguage.other
							? props.preliminaries.firstlanguage.other
							: l10n.preliminary_firstLanguage_choices[props.preliminaries.firstlanguage?.value as FirstLanguageKeys]} />
				}
				{
					props.preliminaries.fillreason &&
					<PreliminaryFieldEntry title={l10n.preliminary_answer_fillReason_title} value={props.preliminaries.fillreason.value === NoAnswer
						? l10n.finish_noAnswer
						: props.preliminaries.fillreason.other
							? props.preliminaries.fillreason.other
							: l10n.preliminary_fillReason[props.preliminaries.fillreason?.value as FillReasonKeys]} />
				}
				{
					props.preliminaries.activity &&
					<PreliminaryFieldEntry title={l10n.preliminary_answer_activity_title} value={props.preliminaries.activity.value === NoAnswer
						? l10n.finish_noAnswer
						: props.preliminaries.activity.other
							? props.preliminaries.activity.other
							: l10n.preliminary_activity[props.preliminaries.activity?.value as ActivityKeys]} />
				}
				{
					props.preliminaries.education &&
					<PreliminaryFieldEntry title={l10n.preliminary_answer_education_title} value={props.preliminaries.education.value === NoAnswer
						? l10n.finish_noAnswer
						: props.preliminaries.education.other
							? props.preliminaries.education.other
							: l10n.preliminary_education_choices[props.preliminaries.education?.value as EducationKeys]} />
				}
			</ul>
		</div >
	)
}